/*
 * Copyright 2022 Siemens
 */

import {SwwcCommandButton, SwwcGlobalFrame, SwwcPrimaryNavigation} from '@com.siemens.plm.horizon/swwc/bindings/react';
import React from 'react';
import {Settings} from '../services/settings';
import App from '../App';
import {Datastores} from '../services/datastores';
import {SwwcInformationBar} from '@com.siemens.plm.horizon/swwc/bindings/react';
import {Authentication} from '../services/authentication';

interface FrameProps {
  children: React.ReactNode | ReadonlyArray<React.ReactNode>;
}

interface FrameState {
  authenticationRequired?: boolean;
  deltaBanner?: boolean;
}

export class Frame extends React.Component<FrameProps, FrameState> {
  readonly #symbol = Symbol('Frame');

  constructor(props: FrameProps, state: FrameState) {
    super(props, state);
    this.state = state || {};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.deltaStatus.addObserver(this.#symbol, (value) => {
      this.setState({deltaBanner: value === false});
    });
    Authentication.authenticated.addObserver(this.#symbol, (value) => {
      this.setState({authenticationRequired: value !== true});
    });
  }

  override componentWillUnmount() {
    Authentication.authenticated.removeObserver(this.#symbol);
    Datastores.deltaStatus.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  override render() {
    return (
      <SwwcGlobalFrame app-name={Settings.application.NAME.SUITE}>
        <SwwcPrimaryNavigation
          slot='primary-navigation'
          onClickNavEvent={() => App.navigate('/me')}
        >
          <img
            slot='edge-icon-top'
            src='/inapp.png'
            alt={Settings.application.NAME.SUITE}
            onClick={() => App.navigate('/')}
          />

          <div slot='top-section--command-items'>
            <SwwcCommandButton
              id='swwc-nav-cmd-experiment'
              orientation='vertical'
              label='Experiments'
              icon='cmdAddPart24'
              onClickEvent={() => App.navigate('/exp')}
            ></SwwcCommandButton>
            <SwwcCommandButton
              id='swwc-nav-cmd-parameterset'
              orientation='vertical'
              label='ParameterSet'
              icon='cmdRecordPartMovement24'
              onClickEvent={() => App.navigate('/pms')}
            ></SwwcCommandButton>
            <SwwcCommandButton
              id='swwc-nav-cmd-job'
              orientation='vertical'
              label='Jobs'
              icon='cmdRecordUtilization24'
              onClickEvent={() => App.navigate('/job')}
            ></SwwcCommandButton>
          </div>
          <div slot='bottom-section--command-items'>
            <SwwcCommandButton
              id='swwc-nav-cmd-download'
              orientation='vertical'
              label='Downloads'
              icon='cmdDownload16'
              onClickEvent={() => App.navigate('/download')}
            ></SwwcCommandButton>
            {Settings.configuration.module.health && (
              <SwwcCommandButton
                id='swwc-nav-cmd-status'
                orientation='vertical'
                label='Status'
                icon='cmdAlerts16'
                onClickEvent={() => App.navigate('/status')}
              ></SwwcCommandButton>
            )}
            {Settings.configuration.module.config && (
              <SwwcCommandButton
                id='swwc-nav-cmd-configuration'
                orientation='vertical'
                label='Configuration'
                icon='cmdSettings16'
                onClickEvent={() => App.navigate('/config')}
              ></SwwcCommandButton>
            )}
            <SwwcCommandButton
              id='swwc-nav-cmd-option'
              orientation='vertical'
              label='Options'
              icon='cmdStar24'
              onClickEvent={() => App.navigate('/option')}
            ></SwwcCommandButton>
            <SwwcCommandButton
              id='swwc-nav-cmd-workspace'
              orientation='vertical'
              label='Workspace'
              icon='cmdProject16'
              onClickEvent={() => App.navigate('/workspace')}
            ></SwwcCommandButton>
            {Settings.configuration.documentation !== null && (
              <SwwcCommandButton
                id='swwc-nav-cmd-status'
                orientation='vertical'
                label='API Doc'
                icon='cmdLibrary16'
                onClickEvent={() => window.open(Settings.configuration.documentation as string, '_blank')}
              ></SwwcCommandButton>
            )}
          </div>
        </SwwcPrimaryNavigation>

        <main slot='content'>
          {this.state.authenticationRequired && (
            <SwwcInformationBar
              closable={false}
              buttonText='Reload'
              fullWidthMode={true}
              informationText='Authenticated session lost, reload to login again'
              label='Error'
              useIcon={true}
              onClickEvent={() => window.location.reload()}
              variant='error'
            />
          )}
          {this.state.deltaBanner && (
            <SwwcInformationBar
              closable={false}
              buttonText='Reconnect'
              fullWidthMode={true}
              informationText='Delta processing for datastore is not available, manual reload required'
              label='Warn'
              useIcon={true}
              onClickEvent={() => Datastores.reset()}
              variant='warning'
            />
          )}
          {this.props.children}
        </main>
      </SwwcGlobalFrame>
    );
  }
}
